export default __webpack_public_path__ + "static/kb_2_8-d88fab7ba94ea58496e867a55be3bd2f.jpg";